import { SET_INIT_DATA, SET_USER_LOGGED_IN, SET_USER_PAGE_STATUS, } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_USER_PAGE_STATUS: {
            const { isActiveUser, isLoggedIn, setupCompleted, userId, userName } = action.payload;
            return Object.assign(Object.assign({}, state), { isActiveUser: isActiveUser === "1", isLoggedIn,
                setupCompleted, initialLoading: false, userId,
                userName });
        }
        case SET_USER_LOGGED_IN: {
            const isLoggedIn = action.payload;
            return Object.assign(Object.assign({}, state), { isLoggedIn });
        }
        case SET_INIT_DATA: {
            const { timezone } = action.payload;
            return Object.assign(Object.assign({}, state), { timezone });
        }
        default:
            return state;
    }
};
export { reducer };
